import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('geoGroupsViewToggle', {
    template: require("../templates/geoGroupsViewToggle.html"),
    controllerAs: '$geoGroupsViewToggleCtrl',
    controller: ['$element', function($element) {
      var self = this;
      var wrapper = $element.closest('.geo-toggle-wrapper-root');
      var form = wrapper.closest('form');

      this.allCustomOptions = componentHelper.allCustomOptions();
      function visibleGroupDivs() {
        return wrapper.find('grouped-associations').find('div:not(.newgroup) > .associationGroup:not(.hidden)');
      }

      this.setValue = function(value) {
        self.value = value;
        wrapper.find('[js-role="geo-group-fields"]').toggleClass('hidden', !value);

        if (value && visibleGroupDivs().length === 0) {
          wrapper.find('grouped-associations').find('.addgroup').trigger('click');
        }
      };

      this.setValue(visibleGroupDivs().length > 0);

      form.on('submit', function(e) {
        if (self.value || self._geoGroupsCleared) return;

        e.preventDefault();
        self._geoGroupsCleared = true;

        var submitter = (e.originalEvent && e.originalEvent.submitter) || document.activeElement;
        if (submitter && submitter.name === 'commit') {
          $('<input>', { type: 'hidden', name: 'commit', value: submitter.value }).appendTo(form);
        }

        clearGeoGroups();
        setTimeout(function() { form.trigger('submit'); }, 0);
      });

      function clearGeoGroups() {
        wrapper.find('grouped-associations').find('div:not(.newgroup) > .associationGroup:not(.hidden) .delgroup').trigger('click');
      }
    }]
});
